import Entity from "./entity";
import Address from "./address";

class Customer extends Entity {
  constructor(data) {
    super(data);

    this.id = data.id || null;
    this.companyName = data.companyName || null;
    this.businessType = data.businessType || null;
    this.area = data.area || null;
    this.note = data.note || null;
    this.deliveryNote = data.deliveryNote || null;
    this.active = data.active || null;
    this.sortOrder = data.sortOrder || null;
    this.parent = data.parent ? new Customer(this.parent) : null;
    this.branches = (data.branches || []).map(branch => new Customer(branch));
    this.companyId = data.companyId || null;
    this.taxId = data.taxId || null;
    this.vatId = data.vatId || null;
    this.address = new Address(data.address);

    this.value = data.id;
    this.label = data.companyName;
  }
}

export default Customer;



// WEBPACK FOOTER //
// ./client/domain/customer.js